import { useIntl } from 'react-intl';

import ProductAutoComplete from '../../../../../../../components/product-auto-complete';
import { noop } from 'ui-components/default-props/noop';

import { messages } from './messages';
import style from './select-products-search-bar.module.less';

/**
 * SelectProductsSearchBar Component
 *
 * A search bar component that integrates with the ProductAutoComplete component to allow product selection.
 * @param {object} props - The component props.
 * @param {string} props.searchTerm - The current search term for the product search input.
 * @param {(term: string) => void} props.setSearchTerm - Function to update the search term, receives the new search term as an argument.
 * @param {(product: object) => void} props.handleProductSelected - Callback triggered when a product is selected from the autocomplete results, receives the selected product as an argument.
 * @returns {JSX.Element} The SelectProductsSearchBar component.
 */
export const SelectProductsSearchBar = ({ searchTerm = '', setSearchTerm = noop, handleProductSelected = noop }) => {
  const intl = useIntl();

  return (
    <div className={style['product-search-bar']}>
      <ProductAutoComplete
        className={style['product-auto-complete']}
        dropdownClassName={style['auto-complete-dropdown']}
        isMultiSelect
        onSelectionMade={handleProductSelected}
        placeholder={intl.formatMessage(messages.searchProductsPlaceholder)}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
    </div>
  );
};
